import { useToast } from '@chakra-ui/react';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import {
  getAssetsDataTableColumns,
  TAssetsDataTableData,
} from './AssetsDataTableMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { getIncomeDataTableColumns } from './IncomeDataTableMeta';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import AssetsAndIncomeDataTableRowFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/customerDetail/AssetsAndIncomeDataTableRowFormUI';
import assetsDataTableRowFormMeta from '../../../formHandler/cardData/customerDetail/assetsAndIncome/AssetsDataTableRowFormMeta';
import incomeDataTableRowFormMeta from '../../../formHandler/cardData/customerDetail/assetsAndIncome/IncomeDataTableRowFormMeta';

const AssetsAndIncomeDataTableHandler = ({
  customerId,
}: {
  customerId: string | number,
}) => {
  const [rowDataTable, setRowDataTable] = React.useState<TAssetsDataTableData>({
    primaryKey: '',
    assetsDescription: '',
    account: '',
    accountHolderName: '',
    flowSubject: false,
    value: '',
  });

  const editAssetsModalRef = React.useRef<any>(null);
  const editIncomeModalRef = React.useRef<any>(null);

  const assetsFormModalRef = React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null);

  const incomeFormModalRef = React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null);

  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['AssetsAndIncome'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve('data'), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  const handleEdit = (row: any, table: "assets" | "income") => {
    setRowDataTable(row.original);

    table === "assets" ? editAssetsModalRef?.current?.onOpen() : editAssetsModalRef?.current?.onOpen();
  };

  const assetsColumns = getAssetsDataTableColumns({
    isLoading,
    handleEdit,
  });

  const incomeColumns = getIncomeDataTableColumns({
    isLoading,
    handleEdit,
  });

  const triggerSubmit = (table: "assets" | "income") => {
    table === "assets" ? assetsFormModalRef?.current?.submitBtnRef?.current?.click() : incomeFormModalRef?.current?.submitBtnRef?.current?.click();
  };

  const onModalFormSubmit = async (payload: any) => {
    console.log('Modal payload: ', payload);
  };

  return (
    <>
      <CustomFieldSet title="Biens">
        <CC.HStack my={3} justifyContent={{ md: 'flex-end', sm: 'center' }}>
          <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
            <CC.Text fontWeight={'bold'}>Total</CC.Text>
            <CC.Text fontWeight={'bold'} fontSize={'3xl'}>
              0000
            </CC.Text>
          </CC.Box>
        </CC.HStack>

        <CustomReactTable data={data || [{}, {}]} columns={assetsColumns} />

        <CustomAppModal
            title="Editer"
            ref={editAssetsModalRef}
            actionBtn={
                <CustomSaveBtn
                isLoading={isLoading}
                isSubmitting={isSubmitting}
                onClick={() => triggerSubmit("assets")}
                />
            }
            actionBtnText={'Valider'}
            size="3xl"
            isCentered
            closeOnOverlayClick={false}
        >
            <AssetsAndIncomeDataTableRowFormUI
                data={rowDataTable}
                meta={assetsDataTableRowFormMeta}
                onSubmit={onModalFormSubmit}
                isLoading={isLoading}
                isSubmitting={isSubmitting}
                ref={assetsFormModalRef}
            />
        </CustomAppModal>
      </CustomFieldSet>

      <CustomFieldSet title="Revenu">
        <CC.HStack my={3} justifyContent={{ md: 'flex-end', sm: 'center' }}>
          <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
            <CC.Text fontWeight={'bold'}>Total</CC.Text>
            <CC.Text fontWeight={'bold'} fontSize={'3xl'}>
              0000
            </CC.Text>
          </CC.Box>
        </CC.HStack>

        <CustomReactTable data={data || [{}, {}]} columns={incomeColumns} />

        <CustomAppModal
            title="Editer"
            ref={editIncomeModalRef}
            actionBtn={
                <CustomSaveBtn
                isLoading={isLoading}
                isSubmitting={isSubmitting}
                onClick={() => triggerSubmit("income")}
                />
            }
            actionBtnText={'Valider'}
            size="3xl"
            isCentered
            closeOnOverlayClick={false}
        >
            <AssetsAndIncomeDataTableRowFormUI
                data={rowDataTable}
                meta={incomeDataTableRowFormMeta}
                onSubmit={onModalFormSubmit}
                isLoading={isLoading}
                isSubmitting={isSubmitting}
                ref={incomeFormModalRef}
            />
        </CustomAppModal>
      </CustomFieldSet>
    </>
  );
};

export default AssetsAndIncomeDataTableHandler;
